var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-button',{staticClass:"vs-con-loading__container",staticStyle:{"border-radius":"5px","width":"100%"},attrs:{"type":"gradient","size":_vm.size,"icon":_vm.icon,"color":_vm.color,"id":"button-with-loading-iadearizalist"},on:{"click":function($event){return _vm.$emit('test-click')}}},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }